export default __webpack_public_path__ + "static/media/Overnight Parking - Coral.e8a0115d.svg";